import styled from "styled-components";
import { Card } from "antd";

export const Wrapper = styled(Card)`
  margin-top: 2.5%;
  margin-right: 8%;
  margin-left: 8%;
  margin-bottom: 10%;
  //height: 55vh;

  .rowContainer {
    display: block;
  }

  .ant-card-body {
    padding-bottom: 50px !important;
  }
`;

